import CourseMain from './modules/course-main';
import CourseCatalog from './modules/course-catalog';
import CourseMixedCourseWare from './modules/course-mixed-courseware';
import CourseEditLock from './modules/course-edit-lock';
import CourseEditAuditSwitch from './modules/course-edit-audit-switch';

export default class {
  public static CourseMain = CourseMain;
  public static CourseCatalog = CourseCatalog;
  public static CourseMixedCourseWare = CourseMixedCourseWare;
  public static CourseEditLock = CourseEditLock;
  public static CourseEditAuditSwitch = CourseEditAuditSwitch;
}
